// Origin Value for tracking url redirects
export const OfficeDotComOrigin = 'OfficeDotCom';
export const OfficeDotComPrvOrigin = 'OfficeDotComPrv';

export const enum WdOriginType {
    Recommended = 'REC',
    RecommendedOpenInBrowser = 'REC-OIB',
    Mru = 'MRU',
    MruOpenInBrowser = 'MRU-OIB',
    Search = 'SEARCH',
    New = 'NEW',
    InstantNew = 'NEW-INSTANT',
    Upload = 'UPLOAD',
    Templates = 'TEMPLATES',
    InstantTemplates = 'TEMPLATES-INSTANT',
    Direct = 'DIRECT',
    BackstageMru = 'BACKSTAGE-MRU',
    Reboot = 'REBOOT',
    Preboot = 'PREBOOT',
    JumpList = 'JUMPLIST',
    Other = 'OTHER'
}

export enum WdOriginPage {
    Home = 'MAIN',
    Start = 'START',
    Content = 'CONTENT',
    Templates = 'TEMPLATES',
    Search = 'SEARCH'
}

export enum WdOriginApp {
    Web = 'WEB',
    HWA = 'HWA',
    PWA = 'PWA',
    NTP = 'NTP',
    Embed = 'EMBED'
}
